import React from 'react';
import PropTypes from 'prop-types';
import { PropTypes as MobxPropTypes, observer, inject } from 'mobx-react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';

import { modelOf } from '../../../prop-types';
import Category from '../../../models/Category';
import RouteService from '../../../services/RouteService';
import NavigationCategoryButton from '../NavigationCategoryButton';

const messages = defineMessages({
  productCategoriesTitle: {
    id: 'navigation.productCategoriesTitle',
    defaultMessage: 'Product categories',
  },
  productCategoriesAriaLabel: {
    id: 'navigation.productCategoriesAriaLabel',
    defaultMessage: 'Select product category',
  },
});

const NavigationSimpleCategoryList = ({ categories, intl }) => {
  const getCategories = () => {
    return categories.map((category) => (
      <li key={category.id}>
        <NavigationCategoryButton category={category} />
      </li>
    ));
  };

  return (
    <nav
      className="NavigationSimpleCategoryList"
      aria-label={intl.formatMessage(messages.productCategoriesAriaLabel)}
    >
      <div className="NavigationSimpleCategoryList__header">
        <h2>{intl.formatMessage(messages.productCategoriesTitle)}</h2>
      </div>
      <ul className="NavigationSimpleCategoryList__categories">
        {getCategories()}
      </ul>
    </nav>
  );
};

NavigationSimpleCategoryList.propTypes = {
  routeService: PropTypes.instanceOf(RouteService).isRequired,
  categories: PropTypes.oneOfType([
    MobxPropTypes.observableArrayOf(modelOf(Category)).isRequired,
    PropTypes.arrayOf(modelOf(Category)).isRequired,
  ]),
  intl: intlShape.isRequired,
};

export default inject('routeService')(
  injectIntl(observer(NavigationSimpleCategoryList))
);
